import { createContext, useContext } from 'react';

import { type JobContext as JobContextType } from '../types';

export const JobContext = createContext({} as JobContextType);

export const useJobContext = () => useContext(JobContext);
